import React from "react";
// import ReactEChartsCore from 'echarts-for-react/lib/core';
// import * as echarts from 'echarts/core';
import ReactECharts from 'echarts-for-react';
// import { getData } from "service/GenericData";
import { addPercentageField } from "util/utils";
import { Provinces } from "util/constants";
// import {
//   PieChart
// } from 'echarts/charts';
// import {
//   TooltipComponent,
// } from 'echarts/components';
// import {
//   SVGRenderer,
// } from 'echarts/renderers';
// echarts.use(
//   [TooltipComponent, PieChart, SVGRenderer]
// );
const PieChartBase = ({
  location,
  lineageData,
  colorRange,
  radius,
  lat
}) => {
  const [isLoading, setIsLoading] = React.useState(true);
  // const minLat = 23 // it's Hainan province
  // const maxLat = 46 // it's Heilongjiang province
  // const midLat = (maxLat - minLat) / 2 + minLat // it's the middle between Hainan and Heilongjiang
  const lowerLat = 30 // (maxLat - minLat) / 3 +minLat
  const upperLat = 40 //(maxLat - minLat)*2 / 3 +minLat
  // console.debug(lowerLat,upperLat)
  var echartRef = React.useRef()


  // Adding conversion from week number to date
  function parseResult(result) {
    if (colorRange.length < result.length) {
      colorRange = colorRange.concat(colorRange)
    }
    result.forEach(function (item, index) {
      item.itemStyle = { color: colorRange[index] }
      item.color = colorRange[index]
    });
    return addPercentageField(result);
  }
  // Polling data
  const [data, setData] = React.useState([]);
  // const [colorPalette, setColorPalette]=React.useState([])
  React.useEffect(() => {
    setIsLoading(true);
    if (colorRange && colorRange.length > 0) {
      if(Provinces[location])
      setData(parseResult(lineageData, colorRange));
      else{
        let echartInstance=echartRef.getEchartsInstance()
        echartInstance.setOption(optionEmpty)
    }
      // setColorPalette(resulttmp.map(item=>item.color))
      setIsLoading(false);
    }
  }, [lineageData, colorRange]);

  // React.useEffect(() => {
  //   setColorPalette(data.map(item=>item.color))
  // }, [data]);
  const optionEmpty={
    series: [
      {
          type: 'pie',
          data: [],
          width: '0%',
          label: {
              show: false
          },
          color: colorRange
      }
  ],
  }
  const optionSmall =
  {
    // tooltip: {
    //   trigger: "item",
    //   // position: [-180, 10], //-180px to the left side and 10px to the top side of the container
    //   position: function (pos, params, dom, rect, size) {
    //     var obj = { left: -180, top: 10 };
    //     // obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
    //     if (lat < midLat)
    //       obj = { left: -180, bottom: 10 }
    //     return obj;
    //   },
    //   formatter: function (params) {
    //     var tooltip = `<p><b>${location} </b></p>`;
    //     tooltip += `${params.marker} ${params.data['name']} : ${params.data['value']} (${params.data['percentage']}) `
    //     tooltip += `<hr >`
    //     tooltip += `<p >`
    //     // console.debug(data)
    //     for (var i = 0; i < data.length; i++) {
    //       if (data[i].value > 0) {
    //         var marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${data[i].color};"></span>`
    //         tooltip += `${marker} ${data[i].name} : ${data[i].value} (${data[i].percentage}) <br/>`
    //       }
    //     }
    //     // tooltip += `${data}`
    //     tooltip += `</p>`;
    //     return tooltip;
    //   }
    // tooltip:{
    //   textStyle:{
    //     fontSize:10
    //   },
    //   position:'inside',
    //   confine: 'true',
    // }
    // ,


    series: [
      {
        id: location,
        // name: chart',
        type: 'pie',
        radius: radius,
        top: "0%",
        center: ['50%', '50%'],
        data: data,
        emphasis: {
          focus: 'series',
          blurScope: 'series',
        },
        label: {
          show: false
        },
        colorBy: 'data',
        tooltip: {
          textStyle: {
            fontSize: 10
          },
          position: 'inside',
          confine: 'true',
        }
        // color: data.map(item=>item.color),
      }
    ],
  };

  const optionBigger = {
    tooltip: {
      trigger: "item",
      // position: [-180, 10], //-180px to the left side and 10px to the top side of the container
      position: function (pos, params, dom, rect, size) {
        var obj = { left: -180, top: 10 };
        // obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
        if (lat < lowerLat)
          obj = { left: -180, bottom: 10 }
        else if (lat > upperLat)
          obj = { left: -180, top: 10 }
        else {
          switch (location) {
            case "Beijing": obj = { left: -180, bottom: -200 }
            case "Shanghai": obj = { left: -180, bottom: -200 }
          }
        }
        return obj;
      },
      formatter: function (params) {
        var tooltip = `<p><b>${Provinces[location]} </b></p>`;
        tooltip += `${params.marker} ${params.data['name']} : ${params.data['value']} (${params.data['percentage']}) `
        tooltip += `<hr >`
        tooltip += `<p >`
        // console.debug(data)
        for (var i = 0; i < data.length; i++) {
          if (data[i].value > 0) {
            var marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${data[i].color};"></span>`
            tooltip += `${marker} ${data[i].name} : ${data[i].value} (${data[i].percentage}) <br/>`
          }
        }
        // tooltip += `${data}`
        tooltip += `</p>`;
        return tooltip;
      },
      appendToBody: true
    },

    series: [
      {
        id: location,
        // name: chart',
        type: 'pie',
        radius: 35,
        top: "0%",
        center: ['50%', '50%'],
        data: data,
        emphasis: {
          focus: 'series',
          blurScope: 'series',
        },
        label: {
          show: false
        },
        colorBy: 'data',
        tooltip: {
          textStyle: {
            fontSize: 10
          },
          position: 'inside',
          confine: 'true',
        }
        // color: data.map(item=>item.color),
      }
    ],
  }
  function onMouseOver(e) {
    var echartInstance = echartRef.getEchartsInstance();
    echartInstance.setOption(optionBigger)
  }

  function onMouseout(e) {
    var echartInstance = echartRef.getEchartsInstance();
    echartInstance.setOption(optionSmall)
  }

  const onEvents = {
    'mouseover': onMouseOver,
    'mouseout': onMouseout
  }

  return (
    <ReactECharts
      // echarts={echarts}
      showLoading={isLoading}
      option={optionSmall}
      opts={{ renderer: 'svg' }}
      style={{ height: 80, width: 80 }}
      onEvents={onEvents}
      ref={(e) => { echartRef = e; }} />
  );
};

export default PieChartBase;
